<div [ngClass]="{'footer':!isGraphPage(), 'footer-graphs':isGraphPage()}">
  <span>© 2006-{{currentYear}} Eurofins Scientific</span>
  <span> | </span>
  <span>{{version}}</span>
  <span *ngIf="isLanguageEnabled">
    <span> | </span>
    {{ getLanguageCode() }}
  </span>
</div>